import React from 'react';
import { useLocation } from 'react-router-dom';
import google from '../../../../assets/img/google.svg';
import facebook from '../../../../assets/img/facebook.svg';
import linkedin from '../../../../assets/img/linkedin.svg';
import twitter from '../../../../assets/img/twitter.svg';
import s from './Steps.module.css';

const SocialLogin: React.FC = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const error = searchParams.get('error');

    const apiUrl = process.env.REACT_APP_API_URL;
    const redirectUrl = `${window.location.origin}/login`;

    const handleSocialLogin = (provider: string) => {
        window.location.href = `${apiUrl}/auth/${provider}?redirect_uri=${redirectUrl}`;
    };

    const getErrorMessage = (code: string): string => {
        switch (code) {
            case 'no_token':
                return 'Authentication failed: No valid token provided.';
            case 'invalid_token_format':
                return 'Invalid token format for linking account.';
            case 'invalid_token':
                return 'Your session is invalid or expired. Please log in again.';
            case 'linkedin_linked':
                return 'This LinkedIn account is already linked to another user.';
            case 'user_not_found':
                return 'User not found. Please try again.';
            case 'different_linkedin_linked':
                return 'Your account is already linked to a different LinkedIn profile.';
            case 'auth_required_for_email_linking':
                return 'Please log in before linking a social account.';
            case 'access_denied':
                return 'You denied access. Please try again.';
            case 'exception':
                return 'An unexpected error occurred. Please try again.';
            default:
                return 'An unknown error occurred. Please try again.';
        }
    };

    return (
        <>
            {error && (
                <div
                    style={{
                        color: '#b91c1c',
                        backgroundColor: '#fee2e2',
                        border: '1px solid #fca5a5',
                        padding: '0.75rem',
                        borderRadius: '0.5rem',
                        marginBottom: '1rem',
                        fontWeight: 500,
                        textAlign: 'center',
                    }}
                >
                    {getErrorMessage(error)}
                </div>
            )}
            <div className={s.social_buttons}>
                <button
                    onClick={() => handleSocialLogin('google')}
                    type="button"
                    className={s.social}
                >
                    <img src={google} alt="Google" className={s.icon} />
                    Continue with Google
                </button>
                {/* <button
                    onClick={() => handleSocialLogin('facebook')}
                    type="button"
                    className={s.social}
                >
                    <img src={facebook} alt="Facebook" className={s.icon} />
                    Continue with Facebook
                </button> */}
                <button
                    onClick={() => handleSocialLogin('linkedin')}
                    type="button"
                    className={s.social}
                >
                    <img src={linkedin} alt="LinkedIn" className={s.icon} />
                    Continue with LinkedIn
                </button>
                {/* <button
                    onClick={() => handleSocialLogin('twitter')}
                    type="button"
                    className={s.social}
                >
                    <img src={twitter} alt="X" className={s.icon} />
                    Continue with X
                </button> */}
            </div>
        </>
    );
};

export default SocialLogin;
